import { flow, identity, pipe } from 'fp-ts/es6/function';
import * as O from 'fp-ts/es6/Option';
import * as _ from './internal';
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.0
 */
export var id = function () { return ({
    get: identity,
    reverseGet: identity
}); };
// -------------------------------------------------------------------------------------
// converters
// -------------------------------------------------------------------------------------
/**
 * View an `Iso` as a `Lens`
 *
 * @category converters
 * @since 2.3.0
 */
export var asLens = _.isoAsLens;
/**
 * View an `Iso` as a `Prism`
 *
 * @category converters
 * @since 2.3.0
 */
export var asPrism = function (sa) { return ({
    getOption: flow(sa.get, O.some),
    reverseGet: sa.reverseGet
}); };
/**
 * View an `Iso` as a `Optional`
 *
 * @category converters
 * @since 2.3.0
 */
export var asOptional = _.isoAsOptional;
/**
 * View an `Iso` as a `Traversal`
 *
 * @category converters
 * @since 2.3.0
 */
export var asTraversal = function (sa) { return ({
    modifyF: function (F) { return function (f) { return function (s) { return F.map(f(sa.get(s)), function (a) { return sa.reverseGet(a); }); }; }; }
}); };
// -------------------------------------------------------------------------------------
// compositions
// -------------------------------------------------------------------------------------
/**
 * Compose an `Iso` with an `Iso`
 *
 * @category compositions
 * @since 2.3.0
 */
export var compose = function (ab) { return function (sa) { return ({
    get: flow(sa.get, ab.get),
    reverseGet: flow(ab.reverseGet, sa.reverseGet)
}); }; };
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 2.3.0
 */
export var reverse = function (sa) { return ({
    get: sa.reverseGet,
    reverseGet: sa.get
}); };
/**
 * @category combinators
 * @since 2.3.0
 */
export var modify = function (f) { return function (sa) { return function (s) { return sa.reverseGet(f(sa.get(s))); }; }; };
export function modifyF(F) {
    return function (f) { return function (sa) { return function (s) { return pipe(sa.get(s), f, function (fa) { return F.map(fa, sa.reverseGet); }); }; }; };
}
// -------------------------------------------------------------------------------------
// pipeables
// -------------------------------------------------------------------------------------
/**
 * @category Invariant
 * @since 2.3.0
 */
export var imap = function (f, g) { return function (ea) {
    return imap_(ea, f, g);
}; };
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var imap_ = function (ea, ab, ba) { return ({
    get: flow(ea.get, ab),
    reverseGet: flow(ba, ea.reverseGet)
}); };
/**
 * @category instances
 * @since 2.3.0
 */
export var URI = 'monocle-ts/Iso';
/**
 * @category instances
 * @since 2.3.0
 */
export var invariantIso = {
    URI: URI,
    imap: imap_
};
/**
 * @category instances
 * @since 2.3.0
 */
export var categoryIso = {
    URI: URI,
    compose: function (ab, ea) { return compose(ab)(ea); },
    id: id
};
